<app-breadcrumb [title]="'Login'" [breadcrumb]="'Login'"></app-breadcrumb>
<!-- section start -->
<section class="login-page section-b-space">
    <div class="container">
        <div class="row content-center">
            <div class="col col-12 content-center">
                <img src="assets/appImages/logoMenu.svg" width="130" height="140" class="img-fluid" alt="logo">
            </div>
            <div class="col-lg-6">
                <div class="theme-card">
                    <form class="theme-form" (ngSubmit)="loginUser()">
                        
                        <!-- Mensaje de error -->
                        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                            {{ errorMessage }}
                        </div>

                        <div class="form-group">
                            <label for="email">Usuario</label>
                            <input type="text" 
                                   class="form-control" 
                                   id="email" 
                                   placeholder="Escriba su usuario" 
                                   [(ngModel)]="registerCredentials.user" 
                                   name="user" 
                                   required
                                   [disabled]="loading">
                        </div>
                        <div class="form-group">
                            <label for="review">Contraseña</label>
                            <div class="password-input-wrapper" style="position: relative;">
                                <input [type]="showPassword ? 'text' : 'password'" 
                                       class="form-control" 
                                       id="review" 
                                       placeholder="Ingrese su contraseña" 
                                       [(ngModel)]="registerCredentials.password" 
                                       name="password" 
                                       required
                                       [disabled]="loading"
                                       style="padding-right: 45px;">
                                <button type="button" 
                                        class="btn-toggle-password" 
                                        (click)="togglePasswordVisibility()"
                                        [disabled]="loading"
                                        style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #666; padding: 5px;">
                                    <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                        <div class="btn-centered">
                            <button type="submit" class="btn btn-solid" [disabled]="loading">
                                {{ loading ? 'Iniciando sesión...' : 'Login' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->